import { ENV } from "../config/env"; // adjust path

export const getUserImage = (image?: string) => {
  if (!image) return null;

  // already full URL
  if (image.startsWith("http")) return image;

  // remove /api from base URL
  const base = ENV.API_BASE_URL.replace("/api", "");

  return `${base}/uploads/${image}`;
};

export const getUserInitial = (name?: string, mobile?: string) => {
  return (
    name?.charAt(0)?.toUpperCase() ||
    mobile?.charAt(0) ||
    "?"
  );
};

export const getAvatarColor = (char: string) => {
  const colors = ["#1976d2", "#388e3c", "#f57c00", "#7b1fa2"];
  return colors[(char.charCodeAt(0) || 0) % colors.length];
};